<template>
    <div id="app">
        <b-container fluid="xl">
            <Menu></Menu>
            <hr class="hr-menu">
            <router-view></router-view>
            <Footer></Footer>
            <hr>
        </b-container>
    </div>
</template>

<script>
    import Menu from "./components/Menu";
    import Footer from "./components/Footer";


    export default {
        name: 'app',
        components: {Menu, Footer}
    }
</script>
<style lang="scss" scoped>
    .container-xl {
        max-width: 1600px;
    }
    .hr-menu {
        margin-top: 0px;
        margin-bottom: 0px;
    }
</style>
